import { createTheme } from '@mui/material';
import { blue, green, grey, lightBlue } from '@mui/material/colors';

export const Cyberpunk = createTheme({
  palette: {
    mode: 'dark', // Define o tema como Dark
    primary: {
      main: blue[400], // Azul claro para manter o contraste em fundo escuro
      dark: blue[700], // Azul profundo para botões e destaques
      light: blue[300], // Azul suave para toques leves
      contrastText: '#ffffff', // Texto branco para boa visibilidade
    },
    secondary: {
      main: green[400], // Verde claro para equilíbrio com o azul
      dark: green[600], // Verde mais forte para ações
      light: green[200], // Verde suave para detalhes
      contrastText: '#ffffff', // Contraste com fundo escuro
    },
    background: {
      paper: grey[900], // Fundo do papel em cinza escuro
      default: grey[800], // Fundo geral em tom mais escuro
    },
    text: {
      primary: grey[100], // Texto principal em cinza claro
      secondary: lightBlue[300], // Destaques em azul claro para contraste
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif", // Fonte moderna e confiável
    h1: {
      fontSize: '2rem', // Tamanho do título principal
      fontWeight: 600, // Peso do título
      color: blue[400], // Azul claro para destacar títulos
    },
    button: {
      textTransform: 'none', // Texto sem transformação para botões
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px', // Bordas arredondadas para suavidade
          border: '1px solid', // Borda visível
          borderColor: green[400], // Verde para destaque
          textShadow: '0 0 2px rgba(255, 255, 255, 0.2)', // Sombra branca suave
          backgroundColor: blue[700], // Fundo azul forte
          color: '#ffffff', // Texto branco
          '&:hover': {
            backgroundColor: blue[600], // Fundo azul mais claro ao passar o mouse
            borderColor: green[500], // Verde mais vivo no hover
            textShadow: '0 0 6px rgba(255, 255, 255, 0.3)', // Sombra mais intensa
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: grey[900], // Fundo escuro para papéis
          color: grey[100], // Texto em cinza claro para contraste
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)', // Sombra forte para profundidade
          borderRadius: '12px', // Bordas suaves
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 400, // Peso confortável para leitura
          lineHeight: 1.5, // Espaçamento para melhor legibilidade
          color: grey[100], // Cor padrão do texto
        },
      },
    },
  },
});
